module.exports = __webpack_public_path__ + "img/sld_vcb_ta1_ba1_hor.381f5e83.svg";